import '../Styles/Footer.css';
export const Footer = () => {
    return (
        <footer>
            All Rights Reserved by <a href="https://www.linkedin.com/in/yaakoubi-mohamed/" target="_blank" rel="noopener noreferrer">Mohamed Yaakoubi</a>
            made within the D4N bootcamp 2024
        </footer>
    );
};
